import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';

@Index('client_contact__fk_client__id_fk', ['fkClientId'], {})
@Index('client_contact_externalId_uindex', ['deletedUserId', 'externalId'], {
	unique: true,
})
@Entity('client_contact')
export class ClientContactEntity extends BaseEntity {
	@Column('int', { name: '_fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('varchar', { name: 'phone', nullable: true, length: 255 })
	public phone!: string | null;

	@Column('varchar', { name: 'fax', nullable: true, length: 255 })
	public fax!: string | null;

	@Column('varchar', { name: 'email', nullable: true, length: 255 })
	public email!: string | null;

	@Column('varchar', { name: 'type', nullable: true, length: 255 })
	public type!: string | null;

	@Column('varchar', { name: 'phoneType', nullable: true, length: 255 })
	public phoneType!: string | null;

	@Column('varchar', { name: 'externalId', nullable: true, length: 255 })
	public externalId!: string | null;

	@Column('varchar', { name: 'title', nullable: true, length: 255 })
	public title!: string | null;

	@Column('varchar', { name: 'extension', nullable: true, length: 64 })
	public extension!: string | null;

	@Column('text', { name: 'note', nullable: true })
	public note!: string | null;

	@Column('datetime', { name: 'externalModifiedDatetime', nullable: true })
	public externalModifiedDatetime!: Date | null;

	// Social profile fields for Recon integration
	@Column('varchar', { name: 'twitter_handle', length: 50, nullable: true })
	public twitterHandle!: string | null;

	@Column('varchar', { name: 'twitter_url', length: 255, nullable: true })
	public twitterUrl!: string | null;

	@Column('varchar', { name: 'linkedin_url', length: 255, nullable: true })
	public linkedinUrl!: string | null;

	@Column('varchar', { name: 'youtube_channel_id', length: 50, nullable: true })
	public youtubeChannelId!: string | null;

	@Column('varchar', {
		name: 'youtube_channel_url',
		length: 255,
		nullable: true,
	})
	public youtubeChannelUrl!: string | null;

	@Column('varchar', { name: 'discord_id', length: 50, nullable: true })
	public discordId!: string | null;

	@Column('varchar', { name: 'discord_username', length: 100, nullable: true })
	public discordUsername!: string | null;

	@Column('varchar', { name: 'reddit_username', length: 50, nullable: true })
	public redditUsername!: string | null;

	@Column('varchar', { name: 'bluesky_handle', length: 100, nullable: true })
	public blueskyHandle!: string | null;

	@OneToMany(() => ClientEntity, (client) => client.fkClientContact, {})
	public clients!: Array<ClientEntity>;

	@ManyToOne(() => ClientEntity, (client) => client.clientContacts, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;
}
